// import React from "react";

// export default function FormActionButtons({
//   onCancel,
//   onSubmit,
//   cancelLabel = "Cancel",
//   submitLabel = "Update",
//   hideSubmit = false,
// }) {
//   return (
//     <div className="d-flex justify-content-end gap-2 mt-3">
//       {/* Cancel Button */}
//       <button
//         type="button"
//         onClick={onCancel}
//         className="btn bor-r c-r px-4 py-2"
//       >
//         {cancelLabel}
//       </button>

//       {/* Submit Button */}
//       {!hideSubmit && (
//         <button
//           type="button"
//           onClick={onSubmit}
//           className="btn bg-dg c-w px-4 py-2"
//         >
//           {submitLabel}
//         </button>
//       )}
//     </div>
//   );
// }


// components/FormActionButtons.jsx

import React from "react";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

export default function FormActionButtons({
  onCancel,
  onSubmit,
  cancelLabel = "Cancel",
  submitLabel = "Update",
  hideSubmit = false,
}) {
  return (
    <Stack direction="row" spacing={2} justifyContent="flex-end" className="m-2">
      {/* Cancel Button */}
      <Button
        variant="contained"
        onClick={onCancel}
        className="bg-rl c-r ac-btn fs-md fw-m px-3 py-2 rounded-3 "
        sx={{
          textTransform: "none",
          boxShadow: "none",
          "&:hover": {
            backgroundColor: "#FFB0A5 !important", // hover override
          },
        }}
      >
        {cancelLabel}
      </Button>

      {/* Submit Button */}
      {!hideSubmit && (
        <Button
          variant="contained"
          onClick={onSubmit}
          className="bg-dg c-w ac-btn fs-md fw-m px-3 py-2 rounded-3 "
          sx={{
            textTransform: "none",
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "#45728b !important", // hover override
            },
          }}
        >
          {submitLabel}
        </Button>
      )}
    </Stack>
  );
}
